import {
  SlAvatar
} from "./chunk.VY7A362G.js";

// src/components/avatar/avatar.ts
var avatar_default = SlAvatar;
SlAvatar.define("sl-avatar");

export {
  avatar_default
};
